import call, { json } from './call';

// Review runs (CONTEXT.md "Review", "Proofread"). A run is one review or one
// proofread of a card; starting a review also proofreads the card, so every
// start returns the list of runs it created.
export const listCardRuns = (token, cardId) => call(`/api/cards/${cardId}/reviews`, token, { method: 'GET' });
export const startCardRuns = (token, cardId, kind) => call(`/api/cards/${cardId}/reviews`, token, json('POST', { kind }));
export const getRun = (token, runId) => call(`/api/reviews/${runId}`, token, { method: 'GET' });
export const cancelRun = (token, runId) => call(`/api/reviews/${runId}`, token, json('PUT', { status: 'cancelled' }));
// Stamps one resolution ('applied' | 'declined') on findings of one run; resolves with the run.
export const resolveFindings = (token, runId, findingIds, resolution) => call(
    `/api/reviews/${runId}`, token, json('PUT', { finding_ids: findingIds, resolution }),
);
export const refineFix = (token, runId, findingId, instruction, currentFix) => call(
    `/api/reviews/${runId}/findings/${findingId}/refine`, token,
    json('POST', { instruction, current_fix: currentFix }),
).then(data => data.replacement_html);

// Course-wide batches: one progress row per card.
// A course proofread can skip the cards unchanged since their last proofread.
export const startCourseRuns = (token, courseId, kind, { skipUnchanged = false } = {}) => call(
    `/api/courses/${courseId}/reviews`, token, json('POST', { kind, skip_unchanged: skipUnchanged }),
);
export const getCourseBatch = (token, courseId, batchId) => call(
    `/api/courses/${courseId}/reviews/batch/${batchId}`, token, { method: 'GET' },
);
// Each card of the course in reading order with the open findings of its latest check.
export const getCourseOpenFindings = (token, courseId) => call(
    `/api/courses/${courseId}/open-findings`, token, { method: 'GET' },
).then(data => data.cards);
export const getCourseReviewSummary = (token, courseId) => call(`/api/courses/${courseId}/review-summary`, token, { method: 'GET' });
